import { GlobalState } from '@/store/global/typing';
import { PayloadAction } from '@reduxjs/toolkit';

export const globalData = {
  increment(state: GlobalState) {
    state.amountOfRiskWarningElements += 1;
  },
  decrement(state: GlobalState) {
    state.amountOfRiskWarningElements = Math.max(0, state.amountOfRiskWarningElements - 1);
  },
  setHeaderHeight(state: GlobalState, payload: PayloadAction<number>) {
    state.headerHeight = payload.payload;
  },
  setReferrer(state: GlobalState, action: PayloadAction<string>) {
    state.referrer = action.payload;
  },
};
